import { useState } from "react";
import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { useCookieConsent } from "@/contexts/CookieConsentContext";

const CookieBanner = () => {
  const { bannerVisible, accept, decline } = useCookieConsent();
  const [showSettings, setShowSettings] = useState(false);
  const [marketingOn, setMarketingOn] = useState(true);

  if (!bannerVisible) return null;

  return (
    <div
      role="dialog"
      aria-label="Cookievoorkeuren"
      className="fixed bottom-0 left-0 right-0 z-[9999] p-3 md:p-5"
    >
      <div className="mx-auto max-w-[1100px] rounded-2xl bg-primary text-primary-foreground shadow-2xl px-5 py-5 md:px-7 md:py-6">
        <div className="flex flex-col md:flex-row md:items-center gap-4 md:gap-8">
          <p className="text-sm md:text-[15px] leading-relaxed text-primary-foreground/85 flex-1">
            We gebruiken cookies om de site te laten werken en om te meten welke advertenties
            bezoekers opleveren. Accepteer je alles, dan werkt de site het beste en kunnen we je
            relevantere advertenties tonen.{" "}
            <Link to="/privacybeleid" className="underline underline-offset-4 hover:text-primary-foreground">
              Privacybeleid
            </Link>
          </p>
          <div className="flex gap-3 shrink-0">
            <Button
              onClick={() => setShowSettings((v) => !v)}
              variant="ghost"
              className="h-11 px-6 rounded-full text-sm font-semibold text-primary-foreground/80 hover:text-primary-foreground hover:bg-primary-foreground/10"
            >
              Aanpassen
            </Button>
            <Button
              onClick={accept}
              className="h-11 px-7 rounded-full text-sm font-semibold bg-accent hover:bg-accent/90 text-accent-foreground"
            >
              Alles accepteren
            </Button>
          </div>
        </div>

        {showSettings && (
          <div className="mt-5 border-t border-primary-foreground/15 pt-5 space-y-4">
            <div className="flex items-start justify-between gap-4">
              <div>
                <p className="text-sm font-semibold">Noodzakelijke cookies</p>
                <p className="text-xs text-primary-foreground/70">
                  Altijd aan. Zonder deze cookies werkt de site niet.
                </p>
              </div>
              <span className="text-xs text-primary-foreground/60 whitespace-nowrap">Altijd aan</span>
            </div>
            <div className="flex items-start justify-between gap-4">
              <div>
                <p className="text-sm font-semibold">Marketing en meten (Meta)</p>
                <p className="text-xs text-primary-foreground/70">
                  Meet welke advertenties bezoekers en aanvragen opleveren.
                </p>
              </div>
              <label className="inline-flex items-center gap-2 text-xs cursor-pointer whitespace-nowrap">
                <input
                  type="checkbox"
                  checked={marketingOn}
                  onChange={(e) => setMarketingOn(e.target.checked)}
                  className="h-4 w-4 accent-[hsl(var(--accent))]"
                />
                {marketingOn ? "Aan" : "Uit"}
              </label>
            </div>
            <div className="flex gap-3 justify-end">
              <Button
                onClick={() => (marketingOn ? accept() : decline())}
                variant="ghost"
                className="h-10 px-5 rounded-full text-sm font-semibold text-primary-foreground/80 hover:text-primary-foreground hover:bg-primary-foreground/10"
              >
                Keuze opslaan
              </Button>
              <Button
                onClick={accept}
                className="h-10 px-6 rounded-full text-sm font-semibold bg-accent hover:bg-accent/90 text-accent-foreground"
              >
                Alles accepteren
              </Button>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default CookieBanner;
